import { BaseApi } from '@/services/api/base-api.ts';
import { z } from 'zod';
import zodCompanyDto from '@/schemas/company/zod-CompanyDto.js';

export type CompanyDto = z.infer<typeof zodCompanyDto>;

const CompanyDtoList = z.array(zodCompanyDto);

export class CompanyApi extends BaseApi {
  constructor() {
    super();
  }

  async changeCompanyAsync(companyCd: string) {
    return this.requestAsync({
      schema: z.string(),
      url: `company/${companyCd}/change`,
    });
  }

  async listByManagedMeAsync() {
    return this.requestAsync({
      schema: CompanyDtoList,
      url: 'companies/managed/me',
    });
  }
}
